import { SignatureFieldContext } from '../../interfaces/signature';
import { SerializedFieldContext } from '../content-control-to-field-map.service';

/**
 * The paste location enum.
 *
 * Document = anywhere on the document that is not in a field content control
 *
 * DataField = one of the FieldType enum values excluding Signature (i.e. Entity, DocumentSender, Script)
 *
 * SignatureField = a signature field (i.e. not a DataField)
 *
 * ConditionalField = a Conditional field
 */
export enum PasteLocationEnum {
  Document,
  DataField,
  SignatureField,
  ConditionalField,
}

/**
 * The paste location that represents somewhere in the document that is not in a field content control.
 */
export type PasteLocationDocument = undefined;

/**
 * The paste location data.
 * - location type: (PasteLocationEnum - Document, DataField, SignatureField)
 * - location: the location in the document - can be the document, a data field or a signature field
 */
export type PasteLocation = {
  type: PasteLocationEnum;
  location: PasteLocationDocument | SerializedFieldContext | SignatureFieldContext;
};
